import React from 'react';
import createReactClass from 'create-react-class';

import { withContainer } from 'core/cache';

import getInitiativeFilters from '../helpers/getInitiativeFilters';
import { getInitiatives } from '../helpers/getMockData';
import groupInitiativesByType from '../helpers/groupInitiativesByType';

import Initiatives from '../components/initiatives';

const initialQuery = getInitiativeFilters().reduce((a, { key }) => (
  { ...a, ...{ [key]: null } }
), {});

const InitiativesContainer = createReactClass({
  handleClearButtonClick() {
    this.fetchInitiatives(initialQuery);
  },

  handleCreateButtonClick() {
    this.props.history.push('/initiatives/new');
  },

  handleFilterChange({
    isSelected,
    isSingleSelect,
    key,
    value,
  }) {
    if (isSingleSelect) {
      this.fetchInitiatives({ [key]: isSelected ? value : null }, { setType: 'extend' });

      return;
    }

    const currentValues = this.props.initiatives.query[key] || [];

    const newValues = isSelected
      ? [...currentValues, value]
      : currentValues.filter((currentValue) => currentValue !== value);

    this.fetchInitiatives({ [key]: newValues }, { setType: 'extend' });
  },

  fetchInitiatives(query, options) {
    const { initiatives } = this.props;

    initiatives.setQuery(query, options);
    initiatives.fetch();
  },

  render() {
    const { initiatives: { data, query, status } } = this.props;

    return (
      <Initiatives
        filters={getInitiativeFilters()}
        initiatives={groupInitiativesByType(data)}
        isFiltered={Object.values(query).some((value) => value !== null)}
        isLoading={status !== 'success'}
        onClearButtonClick={this.handleClearButtonClick}
        onCreateButtonClick={this.handleCreateButtonClick}
        onFilterChange={this.handleFilterChange}
        filterSelection={query}
      />
    );
  },
});

export default withContainer(InitiativesContainer, {
  cache: {
    initiatives: {
      getMockedResponse: () => ({ data: getInitiatives() }),
      initialData: [],
      isMocked: false,
      query: initialQuery,
      transform: ({ data }) => data.data,
      url: '/api/admin/initiatives',
    },
  },
  hasRouter: true,
});
